import { Component, Input } from '@angular/core';

@Component({
  selector: 'cpd-dialog-container',
  templateUrl: './dialog-container.component.html',
  styleUrls: ['./dialog-container.component.scss'],
})
export class DialogContainerComponent {
  @Input() dialogTitle: string;
  @Input() isCloseIconVisible: string;
  @Input() wrapTitle = false;
}
